//Generated File 
export default class FAEntities{
	static readonly AggFATransferRequest = `AggFATransferRequest`;
	static readonly AggrAdditionDeduction = `AggrAdditionDeduction`;
	static readonly AggrFADepreciation = `AggrFADepreciation`;
	static readonly AggrFADisposalDoc = `AggrFADisposalDoc`;
	static readonly AggrFAPropertiesDocument = `AggrFAPropertiesDocument`;
	static readonly AggrFATransferDoc = `AggrFATransferDoc`;
	static readonly CustodyType = `CustodyType`;
	static readonly FAAdditionDeduction = `FAAdditionDeduction`;
	static readonly FACheckListItem = `FACheckListItem`;
	static readonly FAClassification1 = `FAClassification1`;
	static readonly FAClassification2 = `FAClassification2`;
	static readonly FAClassification3 = `FAClassification3`;
	static readonly FAClassification4 = `FAClassification4`;
	static readonly FAClassification5 = `FAClassification5`;
	static readonly FAComponentType = `FAComponentType`;
	static readonly FACreationDoc = `FACreationDoc`;
	static readonly FACustody = `FACustody`;
	static readonly FACustodyDeliveryDoc = `FACustodyDeliveryDoc`;
	static readonly FACustodyDisposal = `FACustodyDisposal`;
	static readonly FACustodyPurchaseDocument = `FACustodyPurchaseDocument`;
	static readonly FACustodyTransferDocument = `FACustodyTransferDocument`;
	static readonly FADeliveryReceiptDoc = `FADeliveryReceiptDoc`;
	static readonly FADepreciation = `FADepreciation`;
	static readonly FADisposalDocument = `FADisposalDocument`;
	static readonly FAFixedAssetsTaking = `FAFixedAssetsTaking`;
	static readonly FAInitialReceipt = `FAInitialReceipt`;
	static readonly FALCCostDoc = `FALCCostDoc`;
	static readonly FALCProformaInvoice = `FALCProformaInvoice`;
	static readonly FALcExpenseDocument = `FALcExpenseDocument`;
	static readonly FALetterOfCredit = `FALetterOfCredit`;
	static readonly FALocation = `FALocation`;
	static readonly FAMaintenanceCheckList = `FAMaintenanceCheckList`;
	static readonly FAMaintenancePlan = `FAMaintenancePlan`;
	static readonly FAMaintenanceRecord = `FAMaintenanceRecord`;
	static readonly FAMaintenanceRecordRequest = `FAMaintenanceRecordRequest`;
	static readonly FAMaintenanceType = `FAMaintenanceType`;
	static readonly FAMovementInDoc = `FAMovementInDoc`;
	static readonly FAMovementOutDoc = `FAMovementOutDoc`;
	static readonly FAOpeningDocument = `FAOpeningDocument`;
	static readonly FAOpeningDocumentUpdate = `FAOpeningDocumentUpdate`;
	static readonly FAPartialDisposalDoc = `FAPartialDisposalDoc`;
	static readonly FAPreventAssetsDeprec = `FAPreventAssetsDeprec`;
	static readonly FAPropertiesDocument = `FAPropertiesDocument`;
	static readonly FAPurchaseDocument = `FAPurchaseDocument`;
	static readonly FAPurchaseOffer = `FAPurchaseOffer`;
	static readonly FAPurchaseOrder = `FAPurchaseOrder`;
	static readonly FAPurchaseRequest = `FAPurchaseRequest`;
	static readonly FAReceiptDoc = `FAReceiptDoc`;
	static readonly FARevaluation = `FARevaluation`;
	static readonly FATransferDocument = `FATransferDocument`;
	static readonly FATransferRequest = `FATransferRequest`;
	static readonly FAType = `FAType`;
	static readonly FixedAsset = `FixedAsset`;
}
